var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    caption: "",
    publicId: "",
    videoId: "",
    fileType: "",
    fileUrl: "",
    fileId: null,
};
var postSlice = createSlice({
    name: "post",
    initialState: initialState,
    reducers: {
        setPost: function (state, action) {
            console.log(action.payload, "payload");
            state.caption = action.payload.caption;
            state.publicId = action.payload.publicId;
            state.videoId = action.payload.videoId;
            state.fileType = action.payload.fileType;
            state.fileUrl = action.payload.fileUrl;
            state.fileId = action.payload.fileId;
        },
        clearPost: function (state) {
            state.caption = "";
            state.publicId = "";
            state.videoId = "";
            state.fileType = "";
            state.fileUrl = "";
            state.fileId = null;
        },
    },
});
export var setPost = (_a = postSlice.actions, _a.setPost), clearPost = _a.clearPost;
export default postSlice.reducer;
